module.exports = __webpack_public_path__ + "img/Hero.480f15b3.svg";